import { useEditor } from "../../EditorContext";


function SubformString({control, formStructure}){

  const { updateFieldUiSchema, updateFieldSchema, updateFieldData } = useEditor()

  return(
    <div className="form">
      <div className="row mb-3">
        <label className="col-sm-2 col-form-label">Максимальное число символов</label>
        <div className="col-sm-8">
          <input
            id="maxLength"
            type="number"
            className="form-control"
            placeholder="введите значение"
            value={control.schemaProps.maxLength}
            onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
          />
        </div>
      </div>

      {/*}
      <div className="row mb-3">
        <div className="form-check ms-3">
          <input
            id="OPTIONS__customRenderer"
            value="fixed_cell"
            type="checkbox"
            className="form-check-input lk-checkbox"
            checked={control.options?.customRenderer == 'fixed_cell'}
            onChange={(e) => {
              // Мы не проставляем readonly=True в schema для фиксированного значения. Возможно надо?
              updateFieldUiSchema(formStructure, control.id, e.target)
            }}
          />
          <label className="form-check-label m-1 ms-2" for="OPTIONS__customRenderer">Фиксированное значение</label>
        </div>
      </div>
      {/*}
      { control.options?.customRenderer == 'fixed_cell' ?
        <div className="row mb-3">
          <div className="col-sm-8">
            <input
              id="initialData"
              type="text"
              className="form-control"
              placeholder="введите значение"
              value={control.initialData}
              onChange={(e) => updateFieldUiSchema(formStructure, control.id, e.target)}
            />
          </div>
        </div>
      :
        <></>
      } 
      */}
    </div>
  )
}

export default SubformString